/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as ConstructionSiteActions from '@construction-sites/store/construction-sites.actions';
import { getTourFilter } from '@construction-sites/store/construction-sites.selectors';
import { State } from '@core/store';
import { ConstructionSitesService } from '@customers/services/construction-sites.service';
import * as  CustomersActions from '@customers/store/customers.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToursService } from '@tours/services/tours.service';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class ConstructionSitesEffects {
  constructor(
    private actions$: Actions<CustomersActions.CustomersActions>,
    private constructionSitesService: ConstructionSitesService,
    private toursService: ToursService,
    private store: Store<State>,
    private translateService: TranslateService,
    private snackBarService: MatSnackBar
  ) { }

  
  loadConstructionSites$ = createEffect(() => this.actions$.pipe(
    ofType(ConstructionSiteActions.LOAD_CONSTRUCTION_SITES),
    switchMap((action: ConstructionSiteActions.LoadConstructionSites) => this.constructionSitesService.getActiveConstructionSitesFor(
      action.customerId,
      action.activeOnly
    ).pipe(
      map(constructionSites => new ConstructionSiteActions.LoadConstructionSitesSuccess(constructionSites)),
      catchError(() => of(new ConstructionSiteActions.LoadConstructionSitesFailure()))
    ))
  ));

  
  loadConstructionSitesFailure$ = createEffect(() => this.actions$.pipe(
    ofType(ConstructionSiteActions.LOAD_CONSTRUCTION_SITES_FAILURE),
    switchMap(() => this.translateService.get('constructionSite.errors.load').pipe(
      tap(errorMessage => this.snackBarService.open(errorMessage))
    ))
  ), { dispatch: false });

  
  setTourFilter$ = createEffect(() => this.actions$.pipe(
    ofType(ConstructionSiteActions.SET_TOUR_FILTER),
    map(() => new ConstructionSiteActions.LoadTours())
  ));

  
  loadTours$ = createEffect(() => this.actions$.pipe(
    ofType(ConstructionSiteActions.LOAD_TOURS),
    withLatestFrom(this.store.select(getTourFilter)),
    switchMap(([_, tourFilter]) => this.toursService.getToursForConstructionSite(
      new Date(tourFilter.date.getFullYear(), tourFilter.date.getMonth()),
      tourFilter.constructionSiteId
    ).pipe(
      map(tours => new ConstructionSiteActions.LoadToursSuccess(tours)),
      catchError(() => of(new ConstructionSiteActions.LoadToursFailure()))
    ))
  ));

  
  loadToursFailure$ = createEffect(() => this.actions$.pipe(
    ofType(ConstructionSiteActions.LOAD_TOURS_FAILURE),
    switchMap(() => this.translateService.get('tours.errors.load').pipe(
      tap(errorMessage => this.snackBarService.open(errorMessage))
    ))
  ), { dispatch: false });
}
